import React from "react";

export const NewCampaignContext = React.createContext();